<script setup lang="ts">
  import {
    FormFieldContainer,
    ImageType,
    DropDown,
    InputField,
    type CameraElement,
  } from '@logistiek-zonder-papier/lzp-library'
  import FlowPathInput from '@/components/form/FlowPathInput.vue'

  const field = defineModel<CameraElement>({ required: true })
</script>

<template>
  <div class="field-config-container">
    <FormFieldContainer label="Label">
      <FlowPathInput
        placeholder="e.g. ${customer.logo}"
        hint="Field label. Supports ${...} interpolation."
        v-model="field.label"
        :optional="true"
        type="text"
        :validate-paths="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Quality (0 - 100)">
      <InputField
        type="number"
        placeholder="Quality (0 - 100)"
        v-model="field.quality"
        :optional="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Store Location">
      <InputField
        placeholder="x.path.to.location"
        hint="Target path url."
        v-model="field.storeLocation"
        type="text"
      />
    </FormFieldContainer>

    <DropDown
      :required="true"
      label="Image Type"
      :modelValue="{ value: field.imageType }"
      idKey="value"
      :data="
        Object.values(ImageType).map(value => ({
          value,
        }))
      "
      @update:modelValue="(value: { value: ImageType }) => (field.imageType = value.value)"
    >
      <template #item="{ item }">{{ item.value ?? 'Selecteer een optie' }}</template>
    </DropDown>

    <FormFieldContainer label="Minimum Amount">
      <InputField
        type="number"
        placeholder="Number of photos required"
        v-model="field.min"
        :optional="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Maximum Amount">
      <InputField
        type="number"
        placeholder="Number of photos allowed"
        v-model="field.max"
        :optional="true"
      />
    </FormFieldContainer>

    <FormFieldContainer label="Error message">
      <FlowPathInput
        placeholder="Error message under the field"
        v-model="field.error"
        :optional="true"
        :validate-paths="true"
      />
    </FormFieldContainer>
  </div>
</template>

<style scoped>
  .field-config-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .two-columns {
    display: flex;
    gap: 0.75rem;
  }

  .row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
</style>
